import { Box, Stack } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import {
  CampaignLifecycleStatus,
  type AdminCampaignDto,
} from "Infrastructure/Api/Api";
import { CampaignDatesSection } from "./CampaignDatesSection";
import { PublishAction } from "./PublishAction";
import { LiveCampaignActions } from "./LiveCampaignActions";
import type { Control } from "react-hook-form";
import type { CampaignFormData } from "./campaignFormSchema";

type Props = {
  formId: string;
  onSubmit: React.FormEventHandler;
  control: Control<CampaignFormData>;
  isSubmitting: boolean;
  campaign?: AdminCampaignDto;
  dateMode: CampaignFormData["dateMode"];
  onDateModeChange: (value: string) => void;
  onPublish?: () => void;
  onArchive?: () => void;
  onUnpublish?: () => void;
};

export const ValidityStep = ({
  formId,
  onSubmit,
  control,
  isSubmitting,
  campaign,
  dateMode,
  onDateModeChange,
  onPublish,
  onArchive,
  onUnpublish,
}: Props) => {
  const isDraft = campaign?.status === CampaignLifecycleStatus.Draft;
  const isPublished = campaign?.status === CampaignLifecycleStatus.Published;

  return (
    <PrimaryPaper>
      <Box
        id={formId}
        component="form"
        sx={{ maxWidth: 800 }}
        onSubmit={onSubmit}
      >
        <Stack gap={4}>
          <CampaignDatesSection
            control={control}
            isSubmitting={isSubmitting}
            dateMode={dateMode}
            onDateModeChange={onDateModeChange}
          />
          {isDraft && onPublish && (
            <PublishAction
              isSubmitting={isSubmitting}
              hasReceiver={!!campaign?.receiverUserID}
              onPublish={onPublish}
            />
          )}
          {isPublished && (
            <LiveCampaignActions
              isSubmitting={isSubmitting}
              onUnpublish={onUnpublish}
              onArchive={onArchive}
            />
          )}
        </Stack>
      </Box>
    </PrimaryPaper>
  );
};
